<template>
  <div class="interaction-container" ref="dropdownContainer">
    <label @click="handleDropDownClick()">{{ label }}</label>
    <div class="dropdown__container">
      <div class="dropdown">
        <div class="selected_wrapper" @click="handleDropDownClick()">
          <span class="dropdown_label" v-if="activeOption && !isOpen">
            {{ activeOption }}
          </span>
          <span class="dropdown_label" v-else>
            {{ emptyOption.label }}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2.5"
            stroke="currentColor"
            class="chevron"
            :class="{ active: isOpen }"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>
        <dropdown-wrapper :open="isOpen">
          <div class="option_container" ref="option_container">
            <div
              v-for="option in this.options"
              :key="option"
              class="option"
              :class="{ active: displayedOption === option }"
              :data-option-val="option"
              @click="handleOptionClicked(option)"
            >
              {{ option }}
            </div>
          </div>
        </dropdown-wrapper>
      </div>
    </div>
  </div>
</template>
<script>
import DropdownWrapper from "./DropdownWrapper.vue";
export default {
  components: { DropdownWrapper },
  name: "CustomizerStringDropdown",
  props: {
    // isOpen: {
    //   type: Boolean,
    //   default: false,
    // },
    label: {
      type: String,
    },
    displayImage: {
      type: Boolean,
      default: false,
    },
    isThumbnail: {
      type: Boolean,
      default: false,
    },
    optionFunction: {
      type: String,
    },
    defaultValueFunction: {
      type: String,
    },
    setFunction: {
      type: String,
    },
    emptyOptionFunction: {
      type: String,
    },
    activeOptionFunction: {
      type: String,
    },
    valueTypeFunction: {
      type: String,
    },
    windowEvent: {
      type: String,
    },
  },
  data() {
    return {
      displayedOption: null,
      isOpen: false
    };
  },
  created() {
    this.displayedOption = this.activeOption;
  },
  watch: {
    isOpen(newIsOpen) {
      if (newIsOpen) {
        const scrollTarget = this.$el.querySelector(
          `[data-option-val="${this.activeOption}"]`
        );
        if (scrollTarget) {
          this.$refs.option_container.scrollTop =
            scrollTarget.offsetHeight * this.options.indexOf(this.activeOption);
        }
      }
    },
  },
  computed: {
    options() {
      return this.$store.getters[this.optionFunction];
    },
    activeOption() {
      return this.$store.getters[this.activeOptionFunction];
    },
    defaultValue() {
      return this.$store.getters[this.defaultValueFunction];
    },
    emptyOption() {
      return this.$store.getters[this.emptyOptionFunction];
    },
    valueType() {
      return this.$store.getters[this.valueTypeFunction];
    },
  },
  methods: {
    handleDropDownClick() {
      if (this.isOpen) {
        this.isOpen = false
        // this.$emit("close-dropdown");
        document.removeEventListener('click', this.handleWindowClicked)
      } else {
        this.isOpen = true
        // this.$emit("open-dropdown");
        document.addEventListener('click', this.handleWindowClicked)
      }
    },
    handleWindowClicked(e) {
      // console.log("THIS ONE FIRED?")
      if (!this.$refs.dropdownContainer.contains(e.composedPath()[0])) {
        this.handleDropDownClick()
      }
    },
    handleOptionHover(option) {
      this.displayedOption = option;
    },
    handleOptionClicked(option) {
      if (option != this.displayedOption) {
        this.displayedOption = option;
      this.$store.dispatch(this.setFunction, option);
      if (this.windowEvent) {
        window.dispatchEvent(new CustomEvent(this.windowEvent, {detail: option}));
      }
      this.$emit("option-changed");
      }
    },
  },
};
</script>
<style scoped>
.dropdown {
  padding: 10px 10px 5px;
  border: var(--border-thickness) solid;
  cursor: pointer;
}
.selected_wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 5px;
}
.chevron {
  height: 1rem;
  transition: 0.4s ease-in-out;
}
.chevron.active {
  transform: rotate(180deg);
}
.dropdown_label {
  flex-grow: 1;
  text-align: center;
  user-select: none;
  position: relative;
}
.option_container {
  max-height: 125px;
  overflow: hidden;
  overflow-y: scroll;
  text-align: center;
}
.image_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.details_wrapper {
  text-align: center;
  font-size: 14px;
  padding: 10px;
  background-color: var(--option-details-background);
  color: var(--option-details-foreground);
  user-select: none;
}
.option {
  margin-bottom: 2px;
  user-select: none;
}
.option.active {
  background-color: var(--active-option-background);
  color: var(--active-option-foreground);
}
.option:not(.active):hover {
  background-color: var(--hover-option-background);
  color: var(--hover-option-foreground);
}
.additional_detail {
  margin: 10px 0;
}
img.thumbnail {
  min-height: 80px;
}
img:not(.thumbnail) {
  width: 100%;
  min-height: 200px;
  object-fit: cover;
}
.dropdown_label img {
  height: 25px;
  width: 25px;
  min-height: unset;
  position: absolute;
  left: 0;
}
</style>
